import {
  AutomationActionSyncToDataDestinationDenormalized,
  ExternalServiceType,
  IAutomationActionTemplateSyncToDataDestination,
  InternalStorageInstructionType,
  SyncToDataDestinationTarget
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { LightMdToJsx } from '../../../../../../../services/formatter';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { readSyncConfig } from '../../ActionSettings/SyncToDataDestination/helpers';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

const destinationLabel = (
  type: SyncToDataDestinationTarget['type']
): string => {
  switch (type) {
    case ExternalServiceType.GOOGLE_SHEET:
      return 'Google Sheets';
    case ExternalServiceType.MS_EXCEL:
      return 'Excel';
    case ExternalServiceType.ADP_WORKFORCE_NOW:
      return 'ADP Workforce Now';
    case ExternalServiceType.PERSONIO:
      return 'Personio';
    case ExternalServiceType.BAMBOO_HR:
      return 'BambooHR';
    case ExternalServiceType.UKG:
      return 'UKG Pro';
    case ExternalServiceType.WORKDAY:
      return 'Workday';
    case ExternalServiceType.SALESFORCE:
      return 'Salesforce';
    case InternalStorageInstructionType.USER_PROFILE:
      return 'a Dado field';
  }
};

/**
 * @guide Create a new automation action - 4.2 Add the Summary component
 *
 * One-line summary, e.g. "Sync data about the Participant to Google Sheets".
 */
export const ActionSummarySyncToDataDestination = ({
  a,
  def
}: {
  a:
    | IAutomationActionTemplateSyncToDataDestination
    | AutomationActionSyncToDataDestinationDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();
  const { destination } = readSyncConfig(a);
  const target = destination
    ? destinationLabel(destination.type)
    : t('a data destination');

  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {t('Sync data about the **Participant** to {{ target }}', { target })}
        </LightMdToJsx>
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
